<div class="cookie-banner" *ngIf="isBannerVisible()">
    <div class="cookie-content">
        <div class="title">
            <i class="ph-fill ph-cookie"></i>
            {{ 'doktar_app.cookie.title' | translate }}
        </div>
        <div class="description">
            {{ 'doktar_app.cookie.description' | translate }}
        </div>
    </div>
    <div class="actions">
        <p-button [severity]="'secondary'" (click)="acceptEssentialsOnly()">
            {{ 'doktar_app.cookie.accept_essentials_button_label' | translate }}
        </p-button>
        <p-button [severity]="'primary'" [outlined]="true" (click)="acceptAll()">
            {{ 'doktar_app.cookie.accept_all_button_label' | translate }}
        </p-button>
    </div>
</div>
